<!-- Initial scenario generation view -->
<div *ngIf="!scenariosGenerated">
  <header class="panel-header panel-header-compact">
    <h1>Scenario Generation</h1>
    <p>AI synthesizes your context with real-world threat intelligence</p>
  </header>

  <div
    class="error-container"
    role="alert"
    aria-live="polite"
    *ngIf="generationError"
  >
    <div class="error-banner">
      <span class="error-icon">⚠</span>
      <div class="error-content">
        <p class="error-message">{{ generationError }}</p>
      </div>
      <button type="button" class="error-retry-btn" [disabled]="isGenerating">
        {{ isGenerating ? "Retrying..." : "Retry" }}
      </button>
    </div>
  </div>

  <div class="step-four-form">
    <section class="scope-section">
      <h2>Quick Threats Seeds</h2>

      <div class="chip-group participant-chip-group">
        <button
          type="button"
          class="selection-chip participant-chip"
          *ngFor="let threatSeed of threatSeeds"
          [class.selected]="isThreatSeedSelected(threatSeed.id)"
          (click)="toggleThreatSeed(threatSeed.id)"
        >
          {{ threatSeed.label }}
        </button>
      </div>
    </section>

    <section class="document-section step-four-document-section">
      <div
        class="document-dropzone"
        [class.drag-over]="dragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <div class="document-copy document-copy-rich">
          <h2>Attach Incident / Scenario Document</h2>
          <p>
            Upload a PDF or Word document (incident report, after-action review,
            situation report).
          </p>
          <span>
            Gemini will extract a scenario seed and generate a 4th scenario
            option that stays close to your document.
          </span>
        </div>

        <input
          #fileInput
          type="file"
          class="upload-input"
          multiple
          accept=".doc,.docx,.pdf"
          (change)="onFileSelected($event)"
        />

        <button
          type="button"
          class="upload-button upload-button-step-two"
          (click)="fileInput.click()"
        >
          <img
            src="assets/icons/upload_icon.svg"
            alt="Upload"
            class="upload-button-icon"
          />
          <span>Select File</span>
        </button>
      </div>

      <div class="file-group" *ngIf="uploadedFiles.length > 0">
        <h3>Incident/Scenario File</h3>

        <div class="file-list">
          <div class="file-card" *ngFor="let file of uploadedFiles">
            <div class="file-meta">
              <span class="file-icon">📄</span>
              <div class="file-copy">
                <strong>{{ file.name }}</strong>
                <span>{{ file.sizeLabel }}&nbsp;&nbsp;Completed</span>
              </div>
            </div>

            <button
              type="button"
              class="file-delete"
              aria-label="Remove file"
              (click)="removeFile(file.id)"
            >
              <img src="assets/icons/trash_icon.svg" alt="Delete" />
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="scope-section">
      <h2>Scenario Seed / Threat Description</h2>

      <textarea
        class="scenario-textarea"
        [value]="scenarioDescription"
        placeholder="Major communications infrastructure failure isolates the organization"
        (input)="updateScenarioDescription($event)"
        rows="3"
      ></textarea>
    </section>
  </div>
</div>

<!-- Generated scenarios view -->
<div *ngIf="scenariosGenerated">
  <header class="panel-header panel-header-compact">
    <h1>Scenario Generation</h1>
    <p>AI synthesizes your context with real-world threat intelligence</p>
  </header>

  <div class="generated-scenarios-container">
    <section class="scenario-cards-section">
      <div
        class="scenario-card"
        *ngFor="let scenario of generatedScenarios"
        [class.selected]="isScenarioSelected(scenario.id)"
        (click)="selectScenario(scenario.id)"
      >
        <div class="scenario-card-header">
          <input
            type="radio"
            [id]="scenario.id"
            name="scenario"
            [value]="scenario.id"
            [checked]="isScenarioSelected(scenario.id)"
            class="scenario-radio"
          />
          <span class="scenario-category-chip">{{ scenario.threatType }}</span>
          <div class="scenario-radio-circle"></div>
        </div>

        <h3 class="scenario-title">{{ scenario.title }}</h3>

        <p class="scenario-content">{{ scenario.description }}</p>

        <div class="trigger-events">
          <div class="trigger-event">
            <h4>Trigger Event</h4>
            <p>{{ scenario.triggerEvent }}</p>
          </div>
        </div>

        <div class="immediate-impacts">
          <h4>Immediate Impacts</h4>
          <ul class="scenario-options">
            <li *ngFor="let impact of scenario.immediateImpacts">
              {{ impact }}
            </li>
          </ul>
        </div>

        <div class="real-world-basis">
          <h4>Real-World Basis</h4>
          <p>{{ scenario.realWorldBasis }}</p>
        </div>
      </div>
    </section>

    <section class="feedback-section">
      <label class="feedback-checkbox">
        <input
          type="checkbox"
          [checked]="noFeedbackNeeded"
          (change)="toggleNoFeedback($event)"
        />
        <span class="custom-checkbox"></span>
        <span class="feedback-checkbox-label">
          No feedback needed- proceedwith this scenario as-is
        </span>
      </label>
      <p class="feedback-hint">
        Check this box if your are satisfied with the selected scenario and do
        not wish to provide comments
      </p>

      <div class="feedback-input-section">
        <label class="feedback-textarea-label">
          Your comments on the selected scenario
        </label>
        <p class="feedback-textarea-hint">
          Define what the organization hopes to look at or achieve
        </p>
        <textarea
          class="scenario-textarea feedback-textarea"
          [value]="feedbackComment"
          placeholder="Textfield default"
          (input)="updateFeedback($event)"
          rows="4"
        ></textarea>
      </div>
    </section>
  </div>
</div>
